/**
 * Registry of available dashboards.
 *
 * Each entry maps to a DashboardTile on the landing page.
 * Access is gated by Entra ID security-group membership — the `groupId`
 * field references an environment variable holding the group's object-ID.
 *
 * To add a new dashboard:
 *   1. Create an Entra security group and assign users
 *   2. Add a REACT_APP_DASHBOARD_<NAME>_GROUP env var with the group ID
 *   3. Append an entry to this array
 */

export const DASHBOARDS = [
  // Active — alphabetical
  {
    id: 'expense',
    name: 'Expense Manager',
    description: 'ConnectWise + AMEX',
    url: 'https://expense.nobulate.com',
    groupId: process.env.REACT_APP_DASHBOARD_EXPENSE_GROUP,
    icon: 'expense',
    available: true,
  },
  {
    id: 'projects',
    name: 'Project Dashboard',
    description: 'ConnectWise + Procore',
    url: 'https://projects.nobulate.com',
    groupId: process.env.REACT_APP_DASHBOARD_PROJECTS_GROUP,
    icon: 'projects',
    available: true,
  },
  {
    id: 'sheets',
    name: 'CW Sheets',
    description: 'Export ConnectWise time and expenses to spreadsheets',
    url: 'https://sheets.nobulate.com',
    groupId: process.env.REACT_APP_DASHBOARD_SHEETS_GROUP,
    icon: 'sheets',
    available: true,
  },
  {
    id: 'msp',
    name: 'MSP Dashboard',
    description: 'ConnectWise MSP',
    url: 'https://msp.nobulate.com',
    groupId: process.env.REACT_APP_DASHBOARD_MSP_GROUP,
    icon: 'msp',
    available: true,
  },
  // Coming soon — alphabetical
  {
    id: 'finance',
    name: 'Financial Dashboard',
    description: 'Coming soon',
    url: null,
    groupId: process.env.REACT_APP_DASHBOARD_FINANCE_GROUP,
    icon: 'finance',
    available: false,
  },
];
